import { useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import type { TextInput } from 'react-native'

import { ErrorMessage } from '@/src/general/components/ErrorMessage'
import { TEST_ID } from '@/src/general/constants/testId'
import { useTimeout } from '@/src/general/hooks/useTimeout'
import { useTranslate } from '@/src/lang/useTranslate'

import { AuthDetailsScreen } from '../components/AuthDetailsScreen'
import { AuthInput } from '../components/AuthInput'
import { useOtpEmailStep } from '../hooks/useOtpEmailStep'

type TEmailScreenProps = {
  searchParams?: { redirectTo?: string; email?: string; uik?: string }
}

export const EmailScreen = ({ searchParams = {} }: TEmailScreenProps) => {
  const inputRef = useRef<TextInput>(null)
  const { t } = useTranslate()
  const { email, errorMessage, generalErrorKey, handleEmailChange, isPending, submitEmail } = useOtpEmailStep({
    initialEmail: searchParams.email,
    redirectTo: searchParams.redirectTo,
    uik: searchParams.uik,
  })

  useTimeout(() => {
    inputRef.current?.focus()
  }, 550)

  return (
    <AuthDetailsScreen
      title={<FormattedMessage id="auth.otp.login.title" />}
      isTitleBold
      isPending={isPending}
      isSubmitDisabled={!email.trim()}
      onSubmit={submitEmail}
    >
      <AuthInput
        ref={inputRef}
        testID={TEST_ID.ME.AUTHENTICATION.OTP_EMAIL_INPUT}
        placeholder={` ${t('word.email-address')}`}
        value={email}
        onChangeText={handleEmailChange}
        onSubmitEditing={submitEmail}
        errorMessage={errorMessage}
        autoCapitalize="none"
        inputMode="email"
        returnKeyType="done"
      />
      {generalErrorKey && <ErrorMessage defaultErrorKey={generalErrorKey} />}
    </AuthDetailsScreen>
  )
}
